export default {
  getSetting: '/api/settings/get',
  updateSetting: '/api/settings/updateSellerSetting',
  updateNotifySetting: '/api/settings/updateNotifySetting',
  getSettingList: '/api/settings/list',
}
